import axios from 'axios'
import _ from 'lodash'
import React, { Component } from 'react'
import styled from 'styled-components'
import qs from 'qs'
import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'
import Input from '../UI/Form/Input'
import TextArea from '../UI/Form/TextArea'
import CheckBox from '../UI/Form/Checkbox'
import { required } from '../../utils/validators'
import { device } from '../../utils/helpers'
import { createEnquiry } from '../../actions/enquiries'

const validate = values => {
  const errors = {}
  const requiredFields = [
    'name',
    'company',
    'phone',
    'email',
    'confirm-email',
    'message',
    'privacy'
  ]

  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Necessario'
    }
  })

  if (values.email !== values['confirm-email']) {
    errors['confirm-email'] = 'Le email non corrispondono'
  }
  return errors
}

const Wrapper = styled.form`
  width: 100%;
`

const MobileForm = styled.div`
  @media ${device.tablet} {
    display: none;
  }
`

const DesktopForm = styled.div`
  display: none;

  @media ${device.tablet} {
    display: block;
  }
`

const FormGroup = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin: ${props => props.margin};
`

const LastGroup = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;

  @media ${device.tablet} {
    margin-top: 10px;
  }

  @media ${device.laptop} {
    margin-top: 0.5208333333333334vw;
  }
`

const Recaptcha = styled.div`
  margin-bottom: 0.2604166666666667vw;
  transform-origin:0 0;

  @media ${device.tablet} {
    transform:scale(0.42);
  }

  @media ${device.laptop} {
    transform:scale(0.55);
  }

  @media ${device.laptopM} {
    transform:scale(0.63);
  }

  @media ${device.laptopL} {
    transform:scale(0.77);
  }

  @media ${device.desktop} {
    transform:scale(1);
  }
`

const Button = styled.button`
  font-family: 'BarlowExtraBold';
  display: inline-block;
  outline: none;
  border: 5px solid ${props => props.theme.color.borderPrimary || '#4d4d4d'};
  text-transform: uppercase;
  font-size: 14px;
  padding: 16px 24px;
  transition: all 0.5s ease;
  cursor: pointer;
  color: ${props => props.theme.color.textPrimary || '#4d4d4d'};
  background-color: white;

  @media ${device.tablet} {
    ${'' /* font-size: 21px ;
  padding: 19 50px; */}
    font-size: 1.09375vw;
    padding: 0.9895833333333334vw 2.604166666666667vw;
    border-width: 3px;
    width: 100%;

    &:hover {
      border-width: 3px;
    }
  }
  @media ${device.tablet} {
    border-width: 5px;
  }

  &:hover {
    color: white;
    background-color: ${props => props.theme.color.hoverPrimary};
    border: 5px solid ${props => props.theme.color.borderSecondary};
  }
`

const BottomWrapper = styled.div`
  width: 100%;

  @media ${device.tablet} {
    width: 49%;
  }
`

let Form = class Form extends Component {
  state = {
    privacy: '',
    cookies: '',
    // loaded: false,
  }

  componentDidMount () {
    const script = document.createElement('script')
    script.src = 'https://cdn.iubenda.com/iubenda.js'
    script.async = true
    document.body.appendChild(script)
    axios.get('https://www.iubenda.com/api/privacy-policy/21238999/no-markup')
      .then(response => {
        this.setState({ privacy: response.data.content })
      })
    axios.get('https://www.iubenda.com/api/privacy-policy/21238999/cookie-policy/no-markup')
      .then(response => {
        this.setState({ cookies: response.data.content })
      })
  }

  handleFormSubmit (values) {
    const { pathname } = this.props.location
    if (pathname.includes('strutture')) {
      let { quantity, duration, addon, product } = this.props
      values = _.omit(values, ['confirmEmail', 'confirm-email'])
      if (!values.newsletter) {
        values.newsletter = false
      }
      if (addon) {
        values.addons = [{
          name: addon.name,
          amount: addon.id
        }]
      }
      let data = {
        ...values,
        id_product: product.id,
        quantity: quantity.id,
        id_duration: duration.id,
        type: 'product'
      }
      if (values.privacy) {
        data.privacy = this.state.privacy
        data.cookies = this.state.cookies
      }
      console.log(data)
      this.props.createEnquiry(data, () => {
        window.location.reload()
      })
    } else {
      const { address, durations, average, step3Components, step4Components, packageDetails } = this.props
      values = _.omit(values, ['confirmEmail', 'confirm-email'])
      if (!values.newsletter) {
        values.newsletter = false
      }
      // The current variant gotten from the URL
      // const currentVariant = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).variant
      // The selected duration gotten by the current value of average days in redux state
      const selectedDuration = _.find(durations, { average_days: average })
      const components = [...step3Components, ...step4Components]
      // List of component IDs that are selected
      const componentIDs = components.filter(component => component.selected).map(component => component.id)
      const data = {
        ...values,
        address,
        id_package_variant: parseInt(packageDetails.id),
        id_duration: selectedDuration.id,
        ids_item_variant: componentIDs,
        type: 'sport'
      }
      if (values.privacy) {
        data.privacy = this.state.privacy
        data.cookies = this.state.cookies
      }
      console.log(data)
      this.props.createEnquiry(data, () => {
        const { sport } = this.props.match.params
        this.props.history.push(`/noleggia/${sport}/grazie`)
      })
    }
  }

  render () {
    const { handleSubmit } = this.props
    return (
      <Wrapper onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
        <MobileForm>
          <FormGroup margin='10px 0'>
            <Field
              name='name'
              required
              component={Input}
              type='text'
              width='100%'
              label='NOME E COGNOME'
            />
          </FormGroup>
          <FormGroup margin='10px 0'>
            <Field
              name='company'
              component={Input}
              type='text'
              width='100%'
              label='AZIENDA'
            />
          </FormGroup>
          <FormGroup margin='10px 0'>
            <Field
              name='phone'
              required
              component={Input}
              type='text'
              width='100%'
              label='Telefono'
            />
          </FormGroup>
          <FormGroup margin='10px 0'>
            <Field
              name='email'
              required
              component={Input}
              type='text'
              width='100%'
              label='INDIRIZZO MAIL'
              validate={[required]}
            />
          </FormGroup>
          <FormGroup margin='10px 0'>
            <Field
              name='confirm-email'
              required
              component={Input}
              type='text'
              width='100%'
              label='CONFERMA MAIL'
              validate={[required]}
            />
          </FormGroup>
          <FormGroup margin='10px 0'>
            <Field
              name='message'
              required
              component={TextArea}
              width='100%'
              label='Scrivi un messaggio'
              style={{ textTransform: 'none' }}
              validate={[required]}
            />
          </FormGroup>
          <FormGroup margin='20px 0'>
            <Field
              name='privacy'
              component={CheckBox}
              width='50%'
              type='checkbox'
              style={{ fontSize: '0.8em' }}
              validate={[required]}
              labelLong={<span >Inviando la richiesta dichiari di aver letto e accetti integralmente i nostri <Link to='/condizioni'>Termini e Condizioni d’uso</Link>. Prendi visione della nostra <a href='https://www.iubenda.com/privacy-policy/21238999' className='iubenda-nostyle no-brand iubenda-embed' title='Privacy Policy'>Informativa sulla Privacy</a> e della nostra <a href='https://www.iubenda.com/privacy-policy/21238999/cookie-policy' className='iubenda-nostyle no-brand iubenda-embed' title='Cookie Policy'>Informativa sui Cookie</a>.</span>}
            />
            <Field
              name='newsletter'
              component={CheckBox}
              width='50%'
              label='Desidero iscrivermi alla newsletter'
              type='checkbox'
              style={{ fontSize: '0.8em' }}
            />
          </FormGroup>
          <div className='g-recaptcha' data-sitekey='6Lfd1WwUAAAAADIpl-1dC8_uJ9TjxFpedRRhTr5u' />
          <FormGroup margin='10px 0'>
            <Button
              style={{
                width: '100%',
                // opacity: 0.5,
              }}
              secondary
              type='submit'
            >
              INVIA PREVENTIVO
            </Button>
          </FormGroup>
        </MobileForm>

        <DesktopForm>
          <FormGroup margin='0.2604166666666667vw 0'>
            <Field
              name='name'
              required
              component={Input}
              type='text'
              width='100%'
              label='NOME E COGNOME'
              validate={[required]}
            />
          </FormGroup>
          <FormGroup margin='0.2604166666666667vw 0'>
            <Field
              name='company'
              required
              component={Input}
              type='text'
              width='49%'
              label='AZIENDA'
            />
            <Field
              name='phone'
              required
              component={Input}
              type='text'
              width='49%'
              label='Telefono'
              padding='0 0 0 0.2604166666666667vw'
              validate={[required]}
            />
          </FormGroup>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ width: '50%' }}>
              <FormGroup margin='0.2604166666666667vw 0'>
                <Field
                  name='email'
                  required
                  component={Input}
                  type='text'
                  width='100%'
                  label='INDIRIZZO MAIL'
                  validate={[required]}
                />
              </FormGroup>
              <FormGroup margin='0.2604166666666667vw 0'>
                <Field
                  name='confirm-email'
                  required
                  component={Input}
                  type='text'
                  width='100%'
                  label='CONFERMA MAIL'
                />
              </FormGroup>
            </div>
            <div style={{ width: '50%', paddingLeft: '15px' }}>
              <FormGroup margin='0.2604166666666667vw 0'>
                <Field
                  name='message'
                  component={TextArea}
                  width='100%'
                  label='Scrivi un messaggio'
                  height='8.333333333333334vw'
                />
              </FormGroup>
            </div>
          </div>
          <FormGroup margin='0.2604166666666667vw 0'>
            <Field
              name='privacy'
              component={CheckBox}
              width='49%'
              type='checkbox'
              // to='https://www.iubenda.com/privacy-policy/21238999'
              labelLong={<span style={{ lineHeight: '1em' }}>Inviando la richiesta dichiari di aver letto e accetti integralmente i nostri <Link to='/condizioni'>Termini e Condizioni d’uso</Link>.Prendi visione della nostra <a href='https://www.iubenda.com/privacy-policy/21238999' className='iubenda-nostyle no-brand iubenda-embed' title='Privacy Policy'>Informativa sulla Privacy</a> e della nostra <a href='https://www.iubenda.com/privacy-policy/21238999/cookie-policy' className='iubenda-nostyle no-brand iubenda-embed' title='Cookie Policy'>Informativa sui Cookie</a>.</span>}
            />
            <Field
              name='newsletter'
              component={CheckBox}
              width='49%'
              label='Desidero iscrivermi alla newsletter'
              type='checkbox'
            />
          </FormGroup>
          <LastGroup>
            <BottomWrapper>
              <Recaptcha className='g-recaptcha' data-sitekey='6Lfd1WwUAAAAADIpl-1dC8_uJ9TjxFpedRRhTr5u' />
            </BottomWrapper>
            <BottomWrapper>
              <Button type='submit'
                style={{
                  // opacity: this.state.loaded ? 1 : 0.5,
                }}
              >INVIA PREVENTIVO</Button>
            </BottomWrapper>
          </LastGroup>
        </DesktopForm>
      </Wrapper>
    )
  }
}

function mapStateToProps (state) {
  return {
    address: state.calculator.steps[4].address,
    step3Components: state.calculator.steps[2].components,
    step4Components: state.calculator.steps[3].components,
    average: state.calculator.average,
    durations: state.calculator.durations,
    packageDetails: state.calculator.steps[1].packageDetails
  }
}

Form = connect(mapStateToProps, { createEnquiry })(Form)

Form = reduxForm({
  form: 'PurchaseForm', // a unique identifier for this form
  validate
})(Form)

export default withRouter(Form)



// WEBPACK FOOTER //
// ./src/components/Forms/Purchase.js